import _pickBy from 'lodash/pickBy';

const arrToObj = arr =>
  _pickBy(arr.reduce((prev, cur) => ({ ...prev, ...cur }), {}));

export default arrToObj;
